/**
* Regions JS
* -----------------------------------------------------------------------------
*
* All the JS for the Regions component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'regions',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.regions__available-states span' ).each( function() {
        $( '.regions .state[data-abbr="' + $( this ).text() + '"]' ).addClass( 'is-available' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'regions', COMPONENT );
} )( app );
